import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Table } from 'react-bootstrap';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import AxiosInstance from 'src/components/Axios';
import { Spinner } from 'react-bootstrap';
const fakeDocs = [
    {
        // code: '',
        // type: '',
        fileName: 'Посвідчення водія',
        // description: 'Документ водія',
        ownerName: 'Петрів Петро Петрович',
        dateEnd: "2025-04-25T08:32:34.981Z"

    },
    {
        // code: '',
        // type: '',
        fileName: 'Техпаспорт',
        // description: 'Документ водія',
        ownerName: 'Павлів Павло Павлович',
        dateEnd: "2025-04-25T08:32:34.981Z"

    },
    {
        // code: '',
        // type: '',
        fileName: 'Страхівка',
        // description: 'Документ водія',
        ownerName: 'Мельник Микола Миколайович',
        dateEnd: "2025-04-25T08:32:34.981Z"

    },

]

const urlApi_1 = '/special_machineries';
const urlApi_2 = '/special_machineries_types';
const urlApi_3 = '/special_machineries_docs';

const urlApi_4 = '/special_machineries_type_docs';

export default function JobsSpecialMachinesModal(props) {
    //видалити
    // const [localJobEnd, setLocalJobEnd] = useState(
    //     props.jobEnd ??
    //     "2026-02-13T00:00:00+00:00");

    const [typeDocs, setTypeDocs] = useState([]);
    const [isLoading, setIsLoading] = useState(false)



    async function getSpecialMachineriesTypeDocs() {
        setIsLoading(true)
        return AxiosInstance.get(`${urlApi_4}`
            , {
                params: {
                    // "specialMachineries.id": data.id
                    "specialMachineriesTypes.id": props.machine.type.id
                }
            }).then((response) => {
                console.log("get /api/special_machineries_type_docs/ response", response);
                if (response.data['hydra:member'].length > 0) {
                    setTypeDocs(response.data['hydra:member'])
                }
                return response;
            }).catch(e => console.log(e)).finally(() => {

                setTimeout(() => {
                    setIsLoading(false)
                }, 100)
            })
    }

    useEffect(() => {
        if (props?.machine?.type?.name) {
            getSpecialMachineriesTypeDocs()
        }
        // if (data.driver) {
        //     getDriver()
        // }
        // getSpecialMachineriesDocs()
    }, [])

    // if (isLoading) return null
    if (isLoading) {
        return (
            <Modal {...props} centered>
                <Modal.Body className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                </Modal.Body>
            </Modal>
        )
    }
    const isFakeDate = (dateString) => dateString.startsWith("0100");

    // console.log('typeDocs', typeDocs)
    // console.log('props', props)


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop={false}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.machine.name} {props.machine?.type?.name || <span style={{ color: 'red' }}>Додайте тип техніки</span>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>Перелік синхронізованих з 1с документів</h4>
                <div>
                    <h1 className="mb-3">{name}</h1>
                    {props.machine.dosc.length > 0 && <div style={{
                        display: "flex",
                        justifyContent: 'space-between',
                        border: '1px solid #dee2e6',
                        gap: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}>
                        {/* <div style={{ width: '40px', textAlign: 'center' }}>#</div> */}
                        <div style={{ width: '200px' }}>Назва</div>
                        <div style={{ width: '200px' }}>Власник</div>
                        <div style={{ width: '150px' }}>Термін дії</div>
                        <div style={{ width: '150px' }}>Дата зміни</div>
                    </div>}

                    {/* Просте виведення документів(закоментовано)    */}
                    {/* {props.machine.dosc.map((elem, index) => {
                        return (
                            <>
                                <div style={{ display: "flex", justifyContent: 'space-between', border: '1px solid #dee2e6', gap: '10px', textAlign: 'center', paddingBottom: '10px', paddingTop: '10px' }}>
                                    <div style={{ width: '200px' }}>
                                        {elem.type}
                                    </div>
                                    <div style={{ width: '200px' }}>
                                        {elem.ownerName}
                                    </div>
                                    <div style={{ width: '150px' }}>
                                        {isFakeDate(elem.dateEnd)
                                            ? <span style={{ color: 'red' }}>Терміну дії не вказано</span>
                                            :
                                            (
                                                <span style={{
                                                    color: dayjs(elem.dateEnd).isBefore(dayjs(props.jobEnd)) ? 'red' : 'green'
                                                }}>
                                                    {dayjs(elem.dateEnd).local().format('YYYY-MM-DD HH:mm:ss')}
                                                </span>
                                            )
                                        }
                                    </div>
                                    <div style={{ width: '150px' }}>
                                        


                                        <>
                                            <span>Дата зміни :</span>{" "}
                                            {dayjs(elem.dateModified).local().format('YYYY-MM-DD HH:mm:ss')}
                                        </>
                                    </div>

                                </div>

                            </>
                        )
                    }
                    )
                    } */}

                    {/* Нова логіка для мапу по типу дока */}
                    {/* -------------------  ------------------- */}
                    {/* {typeDocs.map((typeDoc, index) => {
                        const matchedDocs = props.machine.dosc.filter(doc => doc.typeDocs === typeDoc['@id']);

                        // Если документов нет — выводим строку с "Відсутній"
                        if (matchedDocs.length === 0) {
                            return (
                                <div
                                    key={typeDoc['@id']}
                                    style={{
                                        display: "flex",
                                        justifyContent: 'space-between',
                                        gap: '10px',
                                        borderTop: index === 0 ? 'none' : '1px dashed #dee2e6',
                                        borderLeft: '1px solid #dee2e6',
                                        borderRight: '1px solid #dee2e6',
                                        borderBottom: '1px dashed #dee2e6',
                                        textAlign: 'center',
                                        padding: '10px',
                                        color: 'red',
                                        fontStyle: 'italic',
                                    }}
                                >
                                    <div style={{ width: '200px' }}>{typeDoc.type}</div>
                                    <div style={{ width: '200px' }}>Відсутній</div>
                                    <div style={{ width: '150px' }}>—</div>
                                    <div style={{ width: '150px' }}>—</div>
                                </div>
                            );
                        }

                        // ------------------- Якщо доки є------------------
                        return matchedDocs.map((doc) => (
                            <div
                                key={doc.id}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: '10px',
                                    borderTop: '1px solid #dee2e6',
                                    borderLeft: '1px solid #dee2e6',
                                    borderRight: '1px solid #dee2e6',
                                    borderBottom: '1px dashed #dee2e6',
                                    textAlign: 'center',
                                    padding: '10px',
                                    color: 'black',
                                    fontStyle: 'normal',
                                }}
                            >
                                <div style={{ width: '200px' }}>{typeDoc.type}</div>
                                <div style={{ width: '200px' }}>{doc.ownerName || <span style={{ color: 'red' }}>Відсутній</span>}</div>
                                <div style={{ width: '150px' }}>
                                    {isFakeDate(doc.dateEnd)
                                        ? <span style={{ color: 'red' }}>Терміну дії не вказано</span>
                                        : (
                                            <span style={{ color: dayjs(doc.dateEnd).isBefore(dayjs(props.jobEnd)) ? 'red' : 'green' }}>
                                                {dayjs(doc.dateEnd).local().format('YYYY-MM-DD HH:mm:ss')}
                                            </span>
                                        )}
                                </div>
                                <div style={{ width: '150px' }}>
                                    {doc.dateModified
                                        ? dayjs(doc.dateModified).local().format('YYYY-MM-DD HH:mm:ss')
                                        : '—'}
                                </div>
                            </div>
                        ));
                    })} */}
                    {/* ------------------- Кінець блоку ------------------- */}

                    {/* логіка з останнім завантеженним доком і статусом synced */}

                    {typeDocs.map((typeDoc, index) => {
                        const matchedDocs = props.machine.dosc
                            .filter(doc => doc.typeDocs === typeDoc['@id']
                                && doc.status === 'synced'
                            )
                            .sort((a, b) => new Date(b.dateEntered) - new Date(a.dateEntered));

                        const lastDoc = matchedDocs[0];

                        if (!lastDoc) {
                            return (
                                <div
                                    key={typeDoc['@id']}
                                    style={{
                                        display: "flex",
                                        justifyContent: 'space-between',
                                        gap: '10px',
                                        borderTop: index === 0 ? 'none' : '1px dashed #dee2e6',
                                        borderLeft: '1px solid #dee2e6',
                                        borderRight: '1px solid #dee2e6',
                                        borderBottom: '1px dashed #dee2e6',
                                        textAlign: 'center',
                                        padding: '10px',
                                        color: 'red',
                                        fontStyle: 'italic',
                                    }}
                                >
                                    <div style={{ width: '200px' }}>{typeDoc.type}</div>
                                    <div style={{ width: '200px' }}>Відсутній</div>
                                    <div style={{ width: '150px' }}>—</div>
                                    <div style={{ width: '150px' }}>—</div>
                                </div>
                            );
                        }
                        console.log('color', dayjs(lastDoc.dateEnd).isBefore(dayjs(props.jobEnd)))
                        return (
                            <div
                                key={lastDoc.id}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: '10px',
                                    borderTop: '1px solid #dee2e6',
                                    borderLeft: '1px solid #dee2e6',
                                    borderRight: '1px solid #dee2e6',
                                    borderBottom: '1px dashed #dee2e6',
                                    textAlign: 'center',
                                    padding: '10px',
                                    color: 'black',
                                    fontStyle: 'normal',
                                }}
                            >
                                <div style={{ width: '200px' }}>{typeDoc.type}</div>
                                <div style={{ width: '200px' }}>{lastDoc.ownerName || <span style={{ color: 'red' }}>Відсутній</span>}</div>
                                <div style={{ width: '150px' }}>
                                    {isFakeDate(lastDoc.dateEnd)
                                        ? <span style={{ color: 'red' }}>Терміну дії не вказано</span>
                                        : (
                                            <span style={{
                                                color: dayjs(lastDoc.dateEnd).isBefore(dayjs(
                                                    props.jobEnd
                                                    // localJobEnd
                                                )) ? 'red' : 'green'
                                            }}>
                                                {dayjs(lastDoc.dateEnd).local().format('YYYY-MM-DD HH:mm:ss')}
                                            </span>
                                        )}
                                </div>
                                <div style={{ width: '150px' }}>
                                    {lastDoc.dateModified
                                        ? dayjs(lastDoc.dateModified).local().format('YYYY-MM-DD HH:mm:ss')
                                        : '—'}
                                </div>
                            </div>
                        );
                    })}


                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Закрити</Button>
            </Modal.Footer>
        </Modal>
    );
}
